import { render, staticRenderFns } from "./HeaderSimple.vue?vue&type=template&id=7f04208a&"
import script from "./HeaderSimple.vue?vue&type=script&lang=js&"
export * from "./HeaderSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports